import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Claims = () => {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        // 백엔드 API 호출
        const res = await axios.get('/api/claims');
        setClaims(res.data.claims);
      } catch (err) {
        console.error("내역 로드 실패:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchClaims();
  }, []);

  // 처리 상태 UI 렌더링 함수 (기존 Jinja2 {% if status == ... %} 로직)
  const renderStatus = (status) => {
    switch (status) {
      case 'approved':
        return <span className="text-primary fw-semibold">승인됨</span>;
      case 'rejected':
        return <span className="text-danger fw-semibold">반려됨</span>;
      case 'completed':
        return <span className="text-success fw-semibold">처리 완료</span>;
      default:
        return <span className="text-secondary fw-semibold">대기중</span>;
    }
  };

  if (loading) return <div className="container mt-5 text-center">로딩 중...</div>;

  return (
    <div className="container my-2 px-0"  style={{ maxWidth: '600px', paddingTop: '20px' }}>
      <h2 className="mb-3 mx-3">교환반품 내역</h2>

      {!claims || claims.length === 0 ? (
        <div className="alert text-secondary mx-2" style={{ background: '#f1f3f5', fontSize: '13px' }}>신청한 내역이 없습니다.</div>
      ) : (
        claims.map((claim, index) => (
          <div key={index} className="order-card" style={styles.orderCard}>
            <div className="order-header" style={styles.orderHeader}>
              <div className="d-flex product-item align-items-center mb-2">
                <div className="product-thumb me-3" style={styles.productThumb}>
                  <img 
                    src={claim['p.image_path'] 
                          ? `/static/${claim['p.image_path']}` 
                          : '/static/default_product.png'} 
                    alt="상품 이미지"
                    style={styles.thumbImg}
                    onError={(e) => { e.target.src = '/static/default_product.png'; }}
                  />
                </div>                    
                <div className="product-info">
                  <div className="product-name fw-semibold" style={styles.productName}>
                    {claim.product_name}
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <Link to={`/order/detail?order_id=${claim.order_id}`} style={styles.orderLink}>
                  주문번호: {claim.order_id}
                </Link>
              </div>
            </div>

            <div style={styles.claimDetail}>
              <p style={styles.detailText}><small>신청 타입: {claim.type}</small></p>
              <p style={styles.detailText}>
                <small>신청 이유: <br />
                  <span dangerouslySetInnerHTML={{ __html: claim.reason?.replace(/\n/g, '<br />') }} />
                </small>
              </p>
              <p style={styles.detailText}><small>신청 날짜: {claim.created_at}</small></p>

              <p style={styles.detailText}>
                <small>처리 상태: {renderStatus(claim.status)}</small>
              </p>

              {claim.admin_memo && (
                <p style={styles.detailText}>
                  <small><strong>관리자 메모:</strong><br />
                    <span dangerouslySetInnerHTML={{ __html: claim.admin_memo.replace(/\n/g, '<br />') }} />
                  </small>
                </p>
              )}
            </div>
          </div>
        ))
      )}

      {/* 카카오톡 상담 플로팅 버튼 (필요 시 유지) */}
      <a href="http://pf.kakao.com/_xoLMMG/chat" className="float_right"></a>
    </div>
  );
};

// 원본 스타일 시트 이식
const styles = {
  container: { width: '100%', maxWidth: '600px', margin: '0 auto', padding: '0 10px 40px', boxSizing: 'border-box' },
  pageTitle: { marginTop: '20px', fontSize: '1.5rem', fontWeight: 'bold' },
  orderCard: { background: 'white', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', marginBottom: '28px', padding: '20px' },
  orderHeader: { borderBottom: '1px solid #eee', paddingBottom: '12px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' },
  productThumb: { width: '60px', height: '60px', overflow: 'hidden', border: '0px solid #eee', flexShrink: 0 },
  thumbImg: { width: '100%', height: '100%', objectFit: 'contain', borderRadius: '4px' },
  productName: { fontSize: '1rem' },
  orderLink: { color: '#6c757d', textDecoration: 'none', fontSize: '0.85rem' },
  claimDetail: { lineHeight: '1.6' },
  detailText: { marginBottom: '8px', color: '#333' }
};

export default Claims;